import { atom } from 'jotai';

export const preLoginEmailAtom = atom('');
